import { Box, Image } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import Slider from "dependencies/carousel"
import { personalized } from "helpers/product/image-url"

const SliderWrapper = styled(Slider)`
  .slider-control-bottomcenter {
    margin-bottom: -45px;
  }
`

const ProductImages = ({ product }) => {
  const sliderSettings = {
    arrows: false,
    frameAriaLabel: "Gift Product",
    wrapAround: false,
  }
  let images = [product.image || require("images/icons/jewlr.gif")]

  // generate image url based on prefs
  if (product.availableViews && product.availableViews.length > 0) {
    images = product.availableViews.map((view) =>
      personalized(product.styleCode, "xlarge", {
        override_params: { view: view, ...product.prefs },
      })
    )
  }

  return (
    <Box mb={8} mx="auto" width={{ tablet: "325px" }}>
      <SliderWrapper {...sliderSettings}>
        {images.map((image) => (
          <Image
            alt={product.productTitle || product.styleCode}
            key={`giftproduct_${product.styleCode}`}
            ratio="1 / 1"
            src={image}
            width="100%"
          />
        ))}
      </SliderWrapper>
    </Box>
  )
}

ProductImages.propTypes = {
  product: PropTypes.object,
}

export default ProductImages
